<template>
  <v-layout row wrap>
    <v-flex xs12 sm12 md6 lg6 xl6>
      <v-card dark hover>
        <v-chart
          ref="options"
          class="chart"
          @init="initChart"
          :initOptions="initOptions"
          :options="options"
          :auto-resize="true"
          :style="{height:height, width:width}">
        </v-chart>
      </v-card>
    </v-flex>
    <v-flex xs12 sm12 md6 lg6 xl6>
      <v-card height="100px" color="green darken-2">
        <v-card-title primary-title color="red darken-4">
          <h1 class="white--text">Your Package is {{licen}} GB/Days</h1>
        </v-card-title>
      </v-card>
      <v-card height="400px" dark>
        <v-card-title primary-title>
          <h3>Customer Details</h3>
        </v-card-title>
        <h4><B>Customer Name : </B> {{Customer}} </h4>
        <h4><B>Data Average : </B> {{(bpd / 1024 / 1024 / 1024).toFixed(2)+ ' GB'}} </h4>
        <h4><B>Start Date : </B> {{start_date.toDateString()}} </h4>
        <h4><B>End Date : </B> {{end_date.toDateString()}} </h4>
        <h4><B>Remaining Time : </B>{{ remainingTime }}</h4>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import ECharts from 'vue-echarts/components/ECharts'
export default {
  name: 'gauge',
  components: {
    'v-chart': ECharts
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    licen: {
      type: String
    },
    Customer: {
      type: String
    },
    start_date: {
      type: Date
    },
    end_date: {
      type: Date
    },
    total: {
      type: Number,
      default: 0
    },
    bpd: {
      type: Number
    }
  },
  data () {
    return {
      chart: null,
      x: [],
      y: [],
      percent: [],
      initOptions: {
        renderer: 'canvas'
      },
      options: {}
    }
  },
  created () {
    this.initChart()
  },
  methods: {
    async initChart () {
      this.$refs.options.showLoading({
        color: '#4ea397',
        maskColor: 'transparent',
        textColor: '#ccc'
      })
      if (this.licen) {
        let GB = this.bpd / 1024 / 1024 / 1024
        this.$refs.options.hideLoading()
        let gaugeData = []
        let gaugeObj = {}
        if (this.licen === 'POC') {
          // POC = package 5GB
          this.licen = 5
        }
        this.percent = ((GB / this.licen) * 100).toFixed(2) * 1
        gaugeObj['value'] = this.percent
        gaugeObj['name'] = ['Package: ' + GB.toFixed(2) + ' / ' + this.licen + ' GB Per Day']
        gaugeData.push(gaugeObj)
        this.options = {
          tooltip: {
            formatter: '{a} <br/>{b} : {c}%'
          },
          series: [{
            name: 'Event',
            type: 'gauge',
            detail: {
              formatter: '{value}%',
              textStyle: {
                color: 'white'
                }
            },
            data: gaugeData,
            axisLabel: {
              color: '#ccc'
            },
            title: {
              textStyle: {
                color: '#ccc'
              }
            }
          }]
        }
      } else {
        this.$refs.options.hideLoading()
      }
    }
  },
  computed: {
    remainingTime: function () {
      let elapsedTimeInHours = Math.floor((this.end_date - new Date()) / 1000 / 60 / 60)
      return elapsedTimeInHours < 0
              ? 'EXPIRED'
              : elapsedTimeInHours === 0
              ? 'Less than 1 hour'
              : elapsedTimeInHours < 24
                  ? elapsedTimeInHours + ' hour(s)'
                  : elapsedTimeInHours < (24 * 31)
                      ? Math.floor((elapsedTimeInHours / 24)) + ' day(s)'
                      : Math.floor((elapsedTimeInHours / 24 / 31)) + ' month(s)'
    }
  },
  watch: {
    licen: {
      handler: function (licen) {
        this.initChart()
      }
    }
  }
}
</script>
<style scoped>
.chart {
  min-height: 500px
}
</style>



// WEBPACK FOOTER //
// src/components/getLicense.vue